import { StorageService } from './StorageService';
import locales from '../../config/locales.json';
import { DEFAULT_LOCALE } from '../../constants/misc.constants';

const KEY = 'locale';

export const LanguageService = {
    setLocale,
    getCurrentLocale,
    getLocales,
    getLanguageNativeName,
    getDefaultLocale,
    getCountryCode,
    getLanguageName,
};

function setLocale(locale: string): string {
    const _locale = locale.toLowerCase();
    StorageService.setLocal(KEY, _locale);
    // set html lang
    document.documentElement.lang = _locale;
    return _locale;
}

function getLocales(): string[] {
    return Object.keys(locales);
}

function getCurrentLocale(currentlyAllowedLanguages: string[]): string {
    return StorageService.getLocal<string>(
        KEY,
        getDefaultLocale(currentlyAllowedLanguages),
    );
}

function getLanguageNativeName(locale: string): string {
    if (Object.hasOwn(locales, locale)) {
        return locales[locale].nativeName;
    }

    return locale;
}

function getLanguageName(locale: string): string {
    if (Object.hasOwn(locales, locale)) {
        return locales[locale].name;
    }

    return locale;
}

function getCountryCode(locale: string): string {
    if (Object.hasOwn(locales, locale)) {
        return locales[locale].countryCode;
    }

    return locale;
}

function getDefaultLocale(currentlyAllowedLanguages: string[]): string {
    const browserLocales =
        navigator.languages === undefined
            ? [navigator.language]
            : navigator.languages;
    if (!browserLocales) {
        return DEFAULT_LOCALE;
    }

    let locale: string;
    for (const l of browserLocales) {
        locale = l.trim().split(/[-_]/)[0].toLowerCase();

        if (currentlyAllowedLanguages.includes(locale)) {
            return locale;
        }
    }

    if (currentlyAllowedLanguages.length > 0) {
        return currentlyAllowedLanguages[0].toLowerCase();
    }

    return DEFAULT_LOCALE;
}
